"use client";

import Image from "next/image";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface DressModalProps {
  isOpen: boolean;
  onClose: () => void;
  dress: {
    id: string;
    url: string;
    number: string;
    alt: string;
  } | null;
}

export default function DressModal({
  isOpen,
  onClose,
  dress,
}: DressModalProps) {
  if (!dress) return null;

  return (
    <Dialog open={isOpen} onOpenChange={open => !open && onClose()}>
      <DialogContent showCloseButton={true} className="max-w-4xl p-0">
        <DialogHeader className="p-4 pr-16 border-b border-border">
          <DialogTitle className="text-xl font-semibold text-foreground">
            Completed Dress #{dress.number}
          </DialogTitle>
        </DialogHeader>

        <div className="relative w-full max-h-[60dvh] overflow-y-auto">
          <div className="relative aspect-[3/4] w-full min-h-0">
            <Image
              src={dress.url}
              alt={dress.alt}
              fill
              className="object-contain"
              sizes="(max-width: 1024px) 90vw, 80vw"
              quality={75}
            />
          </div>
        </div>

        <div className="p-4 border-t border-border flex flex-wrap items-center justify-between gap-3">
          <p className="text-sm text-muted-foreground">
            Made by our professional dressmakers
          </p>
          <Button variant="default" size="sm" onClick={onClose}>
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
